import { CreateEmployee } from '../../../domain/employees/createEmployee';
import { UpdatedEmployee } from '../../../domain/employees/updateEmployee';
import { EmployeesAdapter } from '../../adapters/employees/employeesAdapters';
import { EmployeeDTO } from '../../http/dtos/employees/employeeDTO';
import { EmployeeListDTO } from '../../http/dtos/employees/employeeListDTO';
import { EmployeeListSelectorDTO } from '../../http/dtos/employees/employeeListSelectorDTO';
import httpClient from '../../http/httpClient';

export const EmployeesRepository = {
    GetEmployeesList: () => {
        return httpClient
            .get('/employees/employees-list')
            .then((response: EmployeeListDTO[]) =>
                EmployeesAdapter.getEmployeesListAdapter(response)
            );
    },

    GetEmployee: (id: string) => {
        return httpClient
            .get('/employees/employee-by-id/' + id)
            .then((response: EmployeeDTO) =>
                EmployeesAdapter.getEmployeeAdapter(response)
            );
    },

    CreateEmployee: (newEmployee: CreateEmployee) => {
        return httpClient
            .post('/employees', newEmployee)
            .then((response) => response);
    },

    UpdateEmployee: (newEmployee: UpdatedEmployee, id: number) => {
        return httpClient
            .put('/employees/update-employee/' + id, newEmployee)
            .then((response) => response);
    },

    GetEmployeesListSelector: () => {
        return httpClient
            .get('/employees/employees-list-selector')
            .then((response: EmployeeListSelectorDTO[]) => response);
    },
};
